/**
 * Global DISPLAY timezone — the single source of truth for how every timestamp in
 * the dashboard is rendered. The top-bar picker writes it; `useFormatTime` / `<Time>`
 * read it, so changing it re-renders every time everywhere. Persisted across reloads.
 *
 * `selected === null` means "follow the system/browser zone" (the default).
 */
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface DisplayTzState {
  selected: string | null;                 // IANA id, or null = follow system
  setSelected: (tz: string | null) => void;
}

export const useDisplayTzStore = create<DisplayTzState>()(
  persist(
    (set) => ({
      selected: null,
      setSelected: (tz) => set({ selected: tz }),
    }),
    { name: 'te:display-tz:v1', storage: createJSONStorage(() => localStorage) },
  ),
);
